import { ShrtflConfig } from 'finviz-charts/app/indicators/configs/shrtfl'
import { ShrtraConfig } from 'finviz-charts/app/indicators/configs/shrtra'
import { ShortInterestData } from 'finviz-charts/app/models/quote/financialAttachmentsData'
import { Position } from 'finviz-charts/types/shared'

import { SpecificChartFunctionality } from '../../constants/common'
import { useCachedLoaderData } from '../../hooks/useCachedLoaderData'
import { QuoteChart } from '../quote/components/QuoteChart'
import { ShortInterestTable } from './ShortInterestTable'

const SHORT_INTEREST_CHART_CONFIG = {
  scrollable: true,
  specificChartFunctionality: SpecificChartFunctionality.quoteFinancials,
}

const SHORT_INTEREST_TA = {
  ...FinvizSettings.TA!,
  overlays: [],
  indicators: [
    {
      name: ShrtflConfig.abbreviation,
      parameters: '',
      position: Position.Below,
    },
    {
      name: ShrtraConfig.abbreviation,
      parameters: '',
      position: Position.Below,
    },
  ],
}

export default function ShortInterest() {
  const { data } = useCachedLoaderData<ShortInterestData[] | null>()

  if (!data || data.length === 0) {
    return (
      <div className="fv-container flex h-60 items-center justify-center text-muted">
        Short interest is not available for this stock.
      </div>
    )
  }

  return (
    <>
      <QuoteChart configOverride={SHORT_INTEREST_CHART_CONFIG} TAOverride={SHORT_INTEREST_TA} />
      <div className="fv-container min-w-[1009px] py-4">
        <ShortInterestTable shortInterests={data} />
      </div>
    </>
  )
}
